import CreateProviderBotContainer from './create-provider-bot-container';

export default CreateProviderBotContainer;
